package club.srams.website.components.sections

import androidx.compose.runtime.Composable
import club.srams.website.SubheadlineTextStyle
import club.srams.website.components.widgets.Carousel
import club.srams.website.components.widgets.KobwebVideoPlayer
import club.srams.website.pages.HeroContainerStyle
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div

@Composable
fun VideoSection(
    title: String
    , videoUrl: String
    , posterUrl: String = ""
) {
    SimpleGrid(
        numColumns = numColumns(
            base = 1
            , md = 2
        )
        , modifier = HeroContainerStyle.toModifier()
            .fillMaxWidth()
            .gap(2.cssRem)
    ) {
        // Left: subheading
        Box {
            Column(Modifier.gap(2.cssRem)) {
                Div(SubheadlineTextStyle.toAttrs()) {
                    SpanText(
                        title, Modifier.color(
                            when (ColorMode.current) {
                                ColorMode.LIGHT -> Colors.Black
                                ColorMode.DARK -> Colors.White
                            }
                        )
                    )
                }
            }
        }

        // Right: carousel
        Div {
            Column {
                KobwebVideoPlayer(
                    videoUrl = videoUrl
                    , posterUrl = posterUrl
                    , modifier = Modifier.fillMaxWidth().height(400.px)
                )
            }
        }
    }
}